import React, { useState } from 'react';
import toast, { NotifyType } from 'utils/toast';
import { setAuthenticator, setRefreshToken } from 'utils/localStorage';
import Input from 'component/shared/Input';
import Button from 'component/shared/Button';
import { AppState } from 'interface/stateApp';
import { User } from 'interface/Personal';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store/store';
import { fetchUserInf } from '../../../redux/slice/masterDataSlice';
import { authenticate } from '../../../service/authenticationService';
import { AuthenticationRequest } from '../../../model/request';
import { unwrapResult } from '@reduxjs/toolkit';

interface IProps {
  onSuccess?: () => void;
  onForgotBtnClick?: (e: any) => void;
  onRegisterBtnClick?: (e: any) => void;
  stateApp: AppState;
  setStateApp: React.Dispatch<React.SetStateAction<AppState>>;
  onData?: any;
}

export default function Login({ stateApp, setStateApp }: IProps) {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState<Partial<User>>({});
  const dispatch = useDispatch<AppDispatch>();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    try {
      const data = await authenticate({
        ...user,
        fromCMS: true,
      } as AuthenticationRequest);
      setAuthenticator(data.accessToken);
      setRefreshToken(data.refreshToken);
      dispatch(fetchUserInf()).then(unwrapResult).then();

      toast(NotifyType.SUCCESS, 'Đăng nhập thành công');
      setStateApp({
        ...stateApp,
        showLoginForm: false,
        showRegisterForm: false,
      });
    } catch (err) {
      console.error(err);
      toast(NotifyType.ERROR, 'Tài khoản mật khẩu không chính xác!');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="flex flex-col items-center">
      <h2 className="text-451544 text-2xl font-semibold mb-3">Đăng nhập</h2>
      <p className="text-451544 text-xl md:text-2xl font-semibold mb-6">
        Chào mừng tới <span className="text-FF0B33">Hành trang số!</span>
      </p>
      <form className="w-full" id="login-form" onSubmit={handleSubmit}>
        <div className="mb-6 flex flex-col">
          <Input
            color="text-6A4E64"
            name="name"
            label="Tên đăng nhập"
            placeholder="Nhập tên đăng nhập"
            required
            onChange={(e: any) => setUser({ ...user, email: e.target.value })}
          />
        </div>

        <div className="mb-2 flex flex-col">
          <Input
            color="text-3E3E3C"
            name="password"
            label="Mật khẩu"
            placeholder="Nhập mật khẩu"
            type="password"
            required
            onChange={(e: any) => setUser({ ...user, password: e.target.value })}
          />
        </div>

        <div className="flex justify-between mb-5">
          {/* <CheckBoxComponent
            label="Ghi nhớ"
            name="save"
          /> */}
        </div>
        <div className="flex flex-col items-center">
          <Button
            type="submit"
            className="bg-451544 text-white rounded-[25px] w-[220px] h-[36px] text-[14.5px] font-semibold mb-8"
            loading={loading}
            id="button-login"
          >
            Đăng nhập
          </Button>
          {/*<AntButton*/}
          {/*  id="button-login"*/}
          {/*  icon={<GoogleOutlined />}*/}
          {/*  href={GOOGLE_AUTH_URL}*/}
          {/*  className="border-FF1D30 text-FF1D30 rounded-[25px] text-[14px] font-semibold mb-2"*/}
          {/*>*/}
          {/*  Đăng nhập bằng Google*/}
          {/*</AntButton>*/}
          {/*<AntButton*/}
          {/*  id="button-login"*/}
          {/*  icon={<FacebookOutlined />}*/}
          {/*  href={FACEBOOK_AUTH_URL}*/}
          {/*  className="border-2F51C8 text-2F51C8 rounded-[25px] text-[14px] font-semibold mb-2"*/}
          {/*>*/}
          {/*  Đăng nhập bằng Facebook*/}
          {/*</AntButton>*/}
        </div>
      </form>
    </div>
  );
}
